import React, { Component } from 'react';
import Select from 'react-select';
import { AddRevenue } from '../../Redux/action/revenueAction';
import {
  allLocationWithShortName,
  dataLocation,
  dataUser,
  spocLocationDetailsZoho,
} from '../Helpers/util';
import './form.css';
import moment, { duration } from 'moment';
import { toast } from 'react-toastify';
import axios from 'axios';
import { getLocationNameById } from '../../utils/getLocationNameById';
import SwInput from '../Common/FormComponent/SwInput';
import SwRadio from '../Common/FormComponent/SwRadio';
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);
const userDataLocal12 = spocLocationDetailsZoho();
const locationWithShortName = allLocationWithShortName();

class GymTrainerServiceRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: UserObj ? UserObj.company_id : null,
      spocid: UserObj ? UserObj.rec_id : null,
      email: UserObj ? UserObj.email : '',
      notes: '',
      locationSpoc: [],
      location: '',
      location1: '',
      locationError: '',
      locationData: [],
      locationNew: [],
      locationId: null,
      files: null,
      attachmentError: '',
      noOfUsers: '',
      duration: null,
      gymTrainer: '',
      noOfUsersError: '',
      durationError: '',
      gymTrainerError: '',
      btnStatus: false,
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: '',
    };
  }

  componentDidMount() {
    var LocationSpoc = JSON.parse(userDataLocal12);
    let locationShort = JSON.parse(locationWithShortName);
    this.setState({ locationNew: locationShort });
    this.setState({
      locationData: LocationSpoc,
    });
  }

  changeSelect = e => {
    if (!e) {
      this.setState({
        location: null,
        location1: '',
        locationId: '',
        locationError: '',
      });
      return;
    }

    this.setState({
      location: e,
      location1: String(e.label),
      locationId: e.value,
      locationError: '',
    });
  };

  handleGymTrainer = event => {
    this.setState({ gymTrainer: event.target.value });
  };

  onNotes = e => {
    this.setState({
      notes: e?.target?.value,
      notesError: '',
    });
  };
  resetValue = () => {
    this.setState({
      location: '',
      notes: '',
      noOfUsersError: '',
      durationError: '',
      gymTrainerError: '',
      noOfUsers: '',
      duration: '',
      gymTrainer: '',
      locationError: '',
      notesError: '',
      attachmentError: '',
    });
    this.setState({
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: '',
    });
  };

  onLocation = e => {
    this.setState({
      location: e?.target?.value,
      location1: String(e.value),
      locationError: '',
    });
  };

  handleDuration = selectedDuration => {
    this.setState({ duration: selectedDuration, durationError: '' });
  };

  handleFile(e) {
    if (e.target.files[0]) {
      this.setState({
        selectedFile: e.target.files[0],
        selectedFileName: e.target.files[0].name,
        imageSrc: window.URL.createObjectURL(e.target.files[0]),
        value: e.target.value,
      });
    }

    // Getting the files from the input
    this.setState({ files: e.target.files });

    if (e.target.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    } else if (e.target.files.length <= 2) {
      this.setState({ attachmentError: '' });
    }
  }

  options1 = [
    { value: '1 Months', label: '1 Month' },
    { value: '3 Months', label: '3 Months' },
    { value: '6 Months', label: '6 Months' },
    { value: '12 Months', label: '12 Months' },
  ];

  handleSubmit = e => {
    e.preventDefault();
    const { noOfUsers, duration, gymTrainer } = this.state;
    let files = this.state.files;
    let formData = new FormData();
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append('file', files[i]);
      }
    }
    const isValidNumber =
      Number.isInteger(Number(noOfUsers)) && Number(noOfUsers) > 0;

    if (this.state.location === null || this.state.location === '') {
      this.setState({ locationError: "Location can't be empty" });
    } else if (!isValidNumber) {
      this.setState({
        noOfUsersError: 'No Of People must be a positive number',
      });
    } else if (!duration) {
      this.setState({ durationError: 'Duration can not be Empty' });
    } else if (!gymTrainer) {
      toast.error('Gym trainer can not be empty');
    } else if (this.state.files != null && this.state.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    } else {
      e.currentTarget.disabled = true;
      let param = {};
      let common_param = {
        company_id: this.state.company_id,
        spoc_id: this.state.spocid,
        email: this.state.email,
        company_name: UserObj.company_name,
        category: 'gym_request',
      };
      let body_param = {
        location_name: this.state.location1,
        no_of_users: noOfUsers,
        duration: duration.value,
        gym_trainer: gymTrainer,
        notes: this.state.notes,
      };
      param.common_param = common_param;
      param.body_param = body_param;


      // AddRevenue(param, this.props.onClose)
      //   .then(() => {
      //     // success handled by onClose
      //     this.setState({ btnStatus: false });
      //     e.currentTarget.disabled = false;
      //   })
      //   .catch(() => {
      //     // error toast already shown in AddRevenue
      //     this.setState({ btnStatus: false });
      //     e.currentTarget.disabled = false;
      //   });
      // e.currentTarget.disabled = false;

      AddRevenue(param, (success, message) => {
        if (success) {
          toast.success(message);
          this.resetValue();
          if (this.props.onClose) {
            this.props.onClose();
          }
        }
        this.setState({ btnStatus: false });
        e.currentTarget.disabled = false;
      });
    }
  };
  render() {
    const selectLocationData = [];
    if (this.state.locationSpoc && this.state.locationSpoc.length > 0) {
      this.state.locationSpoc.map(item => {
        if (item.rec_id) {
          selectLocationData.push({
            value: item['location_name_zoho'],
            label: item['location_name_zoho'],
          });
        }
      });
    }
    return (
      <>
        <div className="row">
          {' '}
          <div className="col-md-12">
            <div className="SwFormGroup">
              {' '}
              <label className="SwFormLabel">
                Location <span className="Required">*</span>
              </label>{' '}
              <SwSelect
                name="location"
                id="gym-location-select"
                onChange={this.changeSelect}
                value={this.state.location}
                options={this.state.locationData}
                isClearable={false}
              />
              <span className="SwTextDanger SwTextSmall">{this.state.locationError}</span>
            </div>
          </div>{' '}
        </div>

        <div className="row">
          <div className="col-md-6">
            {' '}
            <div className="SwFormGroup">
              <label className="SwFormLabel">
                No of users <span className="Required">*</span>
              </label>{' '}
              <SwInput
                type="number"
                id="gym-users-input"
                min="0"
                value={this.state.noOfUsers}
                onChange={e =>
                  this.setState({
                    noOfUsers: e.target.value,
                    noOfUsersError: '',
                  })
                }
              />{' '}
              <span className="SwTextDanger SwTextSmall">{this.state.noOfUsersError}</span>
            </div>
          </div>
          <div className="col-md-6">
            <div className="SwFormGroup">
              {' '}
              <label className="SwFormLabel">
                Duration <span className="Required">*</span>
              </label>{' '}
              <SwSelect
                id="gym-duration-select"
                placeholder="Select"
                options={this.options1}
                value={this.state.duration}
                onChange={this.handleDuration}
              />{' '}
              <span className="SwTextDanger SwTextSmall">{this.state.durationError}</span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="SwFormGroup">
              <label className="SwFormLabel">
                Gym Trainer <span className="Required">*</span>
              </label>
              <SwRadio
                id="gym-trainer-radio1"
                name="gymTrainerRequired"
                label="Yes"
                value="Yes"
                checked={this.state.gymTrainer === 'Yes'}
                onChange={this.handleGymTrainer}
              />
              <SwRadio
                id="gym-trainer-radio2"
                name="gymTrainerRequired"
                label="No"
                value="No"
                checked={this.state.gymTrainer === 'No'}
                onChange={this.handleGymTrainer}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 mt-2">
            <div className="SwFormGroup">
              {' '}
              <label className="SwFormLabel">Notes</label>{' '}
              <SwTextArea
                rows="4"
                id="gym-notes"
                value={this.state.notes}
                onChange={this.onNotes}
              />{' '}
            </div>
          </div>{' '}
        </div>
      </>
    );
  }
}

export default GymTrainerServiceRequest;
